import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { NamedAsyncAdapter } from './named-async.adapter';
import { SharedModel } from '../sharedmodel';
import { ManagedVirtualNetwork } from '../managedvirtualnetwork/managedVirtualNetwork';
import _ from 'lodash';
import { ValueAdapter } from './value.adapter';
import { GlobalVariables } from '../../constants/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ManagedVirtualNetwork),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            alias: '*',
            vNetId: '*',
            preventDataExfiltration: '*'
        }
    }
})
export class ManagedVirtualNetworkAdapter extends NamedAsyncAdapter<
    ManagedVirtualNetwork,
    SharedModel.ManagedVirtualNetworkResource
> {
    protected override async _toResource(
        named: ManagedVirtualNetwork
    ): Promise<SharedModel.ManagedVirtualNetworkResource> {
        const vnetResource = await super._toResource(named);
        if (named.raw) {
            const parsed = JSON.parse(named.raw);
            _.merge(vnetResource, parsed);
        }

        this.properties(vnetResource);
        if (GlobalVariables.enablePreventDataExfiltration) {
            this.properties(vnetResource).preventDataExfiltration = named.preventDataExfiltration;
        }

        return vnetResource;
    }

    protected override async _toModel(
        resource: SharedModel.ManagedVirtualNetworkResource,
        model?: ManagedVirtualNetwork
    ): Promise<ManagedVirtualNetwork> {
        if (!model) {
            model = ManagedVirtualNetwork.MODEL.create<ManagedVirtualNetwork>();
        }
        await super._toModel(resource, model);

        if (GlobalVariables.enablePreventDataExfiltration) {
            model.preventDataExfiltration = this.properties(resource).preventDataExfiltration;
        }

        model.raw = JSON.stringify(await ValueAdapter.remainder(this.context, resource, ManagedVirtualNetwork.MODEL));
        return model;
    }
}
